import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Icon } from "@iconify/react";
import { Drawer, Modal } from "antd";
import LogoutModal from "../../modals/LogoutModal";
import { useTranslation } from "react-i18next";

const AdminSidebar = ({ isDrawerOpen, toggleDrawer }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();
  const location = useLocation();

  const onlogoutClick = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <div className="sidebar-main-container py-[18px] pl-[18px] max-md:hidden max-w-[260px] w-full fixed flex flex-col overflow-y-auto h-screen ">
        <div className="sidebar-logo-container relative h-[147px]">
          <img
            src="../../assets/images/dashboard/dash-side.png"
            alt=""
            className="filter drop-shadow-md relative"
          />
          <div className="flex items-center gap-[13px] absolute top-[18%] left-[50%] transform -translate-x-[50%] min-w-[196px]">
            <Link to="/" target="_blank">
              <img src="../../logo.png" alt="logo" className="logo w-[39px] h-[33px]" />
            </Link>
            <h6 className="text-blue font-medium">{t("adminDashboard.sidebar.logo")}</h6>
          </div>
        </div>

        <div className="sidebar-options-container drop-shadow-md bg-[#F8F8F8] min-h-fit h-full mt-[10px] relative  rounded-b-[20px] rounded-t-[140px]">
          <img
            src="../../assets/images/dashboard/dash-side-bottom.png"
            alt=""
            className="filter  absolute  mt-[-41px]  h-full w-full object-fill"
          />
          <ul className="flex flex-col justify-between relative mt-[40px]  min-h-[calc(100%-43px)] p-[7px] w-full max-w-[254px]">
            <div className="top-options flex flex-col gap-[15px]">
              <p className="font-medium small text-blue px-[20px]">
                {t("adminDashboard.sidebar.main")}
              </p>
              <li>
                <NavLink
                  to="/admin-dashboard"
                  className={({ isActive }) =>
                    `dashLinks w-full max-w-[254px] rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px]  ${
                      isActive ? "bg-darkblue text-white" : "text-medGrey"
                    }`
                  }
                >
                  <Icon icon="lucide:layout-dashboard" width={20} height={20} />
                  <p className="large font-medium">{t("adminDashboard.sidebar.home")}</p>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/users"
                  className={({ isActive }) =>
                    `dashLinks w-full max-w-[254px] rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px] ${
                      isActive ||
                      location.pathname === "/user-details/chat-history" ||
                      location.pathname === "/user-details/files-upload"
                        ? "bg-darkblue text-white"
                        : "text-medGrey"
                    }`
                  }
                >
                  <Icon icon="ph:users-light" width={20} height={20} />
                  <p className="large font-medium">{t("adminDashboard.sidebar.users")}</p>
                </NavLink>
              </li>
              <p className="font-medium small text-blue px-[20px]">
                {t("adminDashboard.sidebar.files")}
              </p>
              <li>
                <NavLink
                  to="/files"
                  className={({ isActive }) =>
                    `dashLinks w-full max-w-[254px] rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px]  ${
                      isActive ? "bg-darkblue text-white" : "text-medGrey"
                    }`
                  }
                >
                  <Icon icon="solar:case-round-outline" width={20} height={20} />
                  <p className="large font-medium">{t("adminDashboard.sidebar.uploadedFiles")}</p>
                </NavLink>
              </li>
              <p className="font-medium small text-blue px-[20px]">
                {t("adminDashboard.sidebar.others")}
              </p>
              <li>
                <NavLink
                  to="/plans"
                  className={({ isActive }) =>
                    `dashLinks w-full max-w-[254px] rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px]  ${
                      isActive ? "bg-darkblue text-white" : "text-medGrey"
                    }`
                  }
                >
                  <Icon icon="ph:flag" width={20} height={20} />
                  <p className="large font-medium">{t("adminDashboard.sidebar.plans")}</p>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/rating-reviews"
                  className={({ isActive }) =>
                    `dashLinks w-full rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px]  ${
                      isActive ? "bg-darkblue text-white" : "text-medGrey"
                    }`
                  }
                >
                  <Icon icon="mynaui:star" width={20} height={20} />
                  <p className="large font-medium">{t("adminDashboard.sidebar.ratingReviews")}</p>
                </NavLink>
              </li>
              {/* <li>
                <NavLink
                  to="/admin-settings"
                  className={({ isActive }) =>
                    `dashLinks w-full max-w-[254px] rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px]  ${
                      isActive ? "bg-darkblue text-white" : "text-medGrey"
                    }`
                  }
                >
                  <Icon icon="akar-icons:gear" width={20} height={20} />
                  <p className="large font-medium">{t("adminDashboard.sidebar.settings")}</p>
                </NavLink>
              </li> */}
            </div>
            <div className="bottom-options ">
              <li
                className="flex text-medGrey items-center gap-[10px] px-[20px] py-[10px] cursor-pointer"
                onClick={onlogoutClick}
              >
                <Icon icon="mi:log-out" width={20} height={20} />
                <p className="large font-medium">{t("adminDashboard.sidebar.logout")}</p>
              </li>
            </div>
          </ul>
        </div>
      </div>

      {/* mobile sidebar */}
      <div className="mobile-sidebar hidden max-md:flex">
        <Drawer
          placement="left"
          closable={false}
          onClose={toggleDrawer}
          open={isDrawerOpen}
          className="rounded-r-[20px] "
          width={340}
        >
          <div className="sidebar-container ">
            <img
              src={
                isDrawerOpen
                  ? "../../assets/icons/sidebarArrow-left.png"
                  : "../../assets/icons/sidebarArrow-right.png"
              }
              alt=""
              className="cursor-pointer absolute right-[-4%] z-[99999]"
              onClick={toggleDrawer}
            />
            <div className="sidebar-logo-container py-[30px]  flex items-center gap-[13px] justify-center">
              <Link to="/" target="_blank">
                <img src="../../logo.png" alt="logo" className="logo w-[39px] h-[33px]" />
              </Link>
              <h6 className="text-blue font-medium">{t("adminDashboard.sidebar.logo")}</h6>
            </div>

            <div className="sidebar-options-container  min-h-fit h-full relative  rounded-b-[20px] rounded-t-[140px]">
              <ul className="flex flex-col gap-[15px] justify-between relative  w-full max-w-full">
                <div className="top-options flex flex-col gap-[15px]">
                  <p className="font-medium small text-blue px-[20px]">
                    {t("adminDashboard.sidebar.main")}
                  </p>
                  <li>
                    <NavLink
                      onClick={toggleDrawer}
                      to="/admin-dashboard"
                      className={({ isActive }) =>
                        `dashLinks w-full rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px]  ${
                          isActive ? "bg-darkblue text-white" : "text-medGrey"
                        }`
                      }
                    >
                      <Icon icon="lucide:layout-dashboard" width={20} height={20} />
                      <p className="large font-medium">{t("adminDashboard.sidebar.home")}</p>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/users"
                      onClick={toggleDrawer}
                      className={({ isActive }) =>
                        `dashLinks w-full rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px] ${
                          isActive ||
                          location.pathname === "/user-details/chat-history" ||
                          location.pathname === "/user-details/files-upload"
                            ? "bg-darkblue text-white"
                            : "text-medGrey"
                        }`
                      }
                    >
                      <Icon icon="ph:users-light" width={20} height={20} />
                      <p className="large font-medium">{t("adminDashboard.sidebar.users")}</p>
                    </NavLink>
                  </li>
                  <p className="font-medium small text-blue px-[20px]">
                    {t("adminDashboard.sidebar.files")}
                  </p>
                  <li>
                    <NavLink
                      to="/files"
                      onClick={toggleDrawer}
                      className={({ isActive }) =>
                        `dashLinks w-full rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px]  ${
                          isActive ? "bg-darkblue text-white" : "text-medGrey"
                        }`
                      }
                    >
                      <Icon icon="solar:case-round-outline" width={20} height={20} />
                      <p className="large font-medium">
                        {t("adminDashboard.sidebar.uploadedFiles")}
                      </p>
                    </NavLink>
                  </li>
                  <p className="font-medium small text-blue px-[20px]">
                    {t("adminDashboard.sidebar.others")}
                  </p>
                  <li>
                    <NavLink
                      to="/plans"
                      onClick={toggleDrawer}
                      className={({ isActive }) =>
                        `dashLinks w-full rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px]  ${
                          isActive ? "bg-darkblue text-white" : "text-medGrey"
                        }`
                      }
                    >
                      <Icon icon="ph:flag" width={20} height={20} />
                      <p className="large font-medium">{t("adminDashboard.sidebar.plans")}</p>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/rating-reviews"
                      onClick={toggleDrawer}
                      className={({ isActive }) =>
                        `dashLinks w-full rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px]  ${
                          isActive ? "bg-darkblue text-white" : "text-medGrey"
                        }`
                      }
                    >
                      <Icon icon="mynaui:star" width={20} height={20} />
                      <p className="large font-medium">
                        {t("adminDashboard.sidebar.ratingReviews")}
                      </p>
                    </NavLink>
                  </li>
                  {/* <li>
                    <NavLink
                      to="/admin-settings"
                      onClick={toggleDrawer}
                      className={({ isActive }) =>
                        `dashLinks w-full rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px]  ${
                          isActive ? "bg-darkblue text-white" : "text-medGrey"
                        }`
                      }
                    >
                      <Icon icon="akar-icons:gear" width={20} height={20} />
                      <p className="large font-medium">{t("adminDashboard.sidebar.settings")}</p>
                    </NavLink>
                  </li> */}
                </div>
                <div className="bottom-options ">
                  <li
                    className="flex text-medGrey items-center gap-[10px] px-[20px] py-[10px] cursor-pointer"
                    onClick={onlogoutClick}
                  >
                    <Icon icon="mi:log-out" width={20} height={20} />
                    <p className="large font-medium">{t("adminDashboard.sidebar.logout")}</p>
                  </li>
                </div>
              </ul>
            </div>
          </div>
        </Drawer>
      </div>
      <LogoutModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </>
  );
};

export default AdminSidebar;
